import React from 'react'
import PropTypes from 'prop-types'
import { ButtonSection, PrimaryButton, SecondaryButton } from './styles'

const Buttons = ({
  primaryButton = { text: '', href: '', externalLink: null, icon: null, onClick: () => {} },
  secondaryButton = { text: '', onClick: () => {} },
}) => {
  const linkAttributes = primaryButton?.href && {
    href: primaryButton.href,
    target: primaryButton.externalLink ? '_blank' : '_self',
    ...(primaryButton.externalLink && { rel: 'noopener noreferrer' }),
  }

  return (
    <ButtonSection>
      <PrimaryButton
        type="primary"
        onClick={primaryButton.onClick}
        singleButton={!Boolean(secondaryButton.text)}
        {...linkAttributes}
      >
        {primaryButton.icon}
        {primaryButton.text}
      </PrimaryButton>
      {Boolean(secondaryButton.text) && (
        <SecondaryButton onClick={secondaryButton.onClick}>{secondaryButton.text}</SecondaryButton>
      )}
    </ButtonSection>
  )
}

Buttons.propTypes = {
  primaryButton: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    externalLink: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
  }),
  secondaryButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
}

export default Buttons
